import React from 'react';
import cx from 'classnames';
import { Typography } from '@material-ui/core';

import { parseError } from 'src/lib/common';
import { useViewState } from './useViewState';

export const PanelError = ({ className }) => {
  const { error } = useViewState();

  const { title, description } = parseError(error);

  return (
    <div className={cx('', className)}>
      <Typography className={'text-error-active font-bold'}>{title}</Typography>
      <Typography className={'text-error-active'}>{description}</Typography>
    </div>
  );
};
